var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "88 -680 823.54 400",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M288-414.77q-27.69 0-46.46-18.77T222.77-480t18.77-46.46T288-545.23t46.46 18.77T353.23-480t-18.77 46.46T288-414.77M288-280q-83.08 0-141.54-58.46T88-480t58.46-141.54T288-680q59.62 0 109.62 32.88 50 32.89 73.76 87.12h360.16l80 80-127.69 114.15-72.47-51.53-64.3 53.07L564.92-424h-81.54q-14.76 66.46-71.26 105.23T288-280m0-32q66.08 0 113.31-42.04T453.23-456h123.39l69.23 49.69 63.3-51.31L784-405.77 865.23-481l-46-47h-371q-16.69-49.92-59.42-84.96T288-648q-70 0-119 49t-49 119 49 119 119 49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.df71bb330d24da691609995986090480.svg";
export { ForwardRef as ReactComponent };